import React from 'react';
import './App.css';
import "./Models/i18Translator";
import { MainContainer } from './Components/MainContainer/MainContainer';
import { ServiceContextProvider } from './Contexts/ServiceContext/ServiceContext';
import { ThemeProvider } from '@emotion/react';
import { SCCOTheme } from './Theme/SCCOTheme';
import { ScopedCssBaseline } from '@mui/material';

function App() {
  return (
    <ScopedCssBaseline>
      <ThemeProvider theme={SCCOTheme}>
        <ServiceContextProvider>
          <MainContainer />
        </ServiceContextProvider>
      </ThemeProvider>
    </ScopedCssBaseline>
  );
}

export default App;
